export default __webpack_public_path__ + "static/media/builds.902e83be.png";